import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";
import {DocumentManager} from "../../Manager/PDFManager/DocumentManager";

export class FormFieldPicker extends DynamicDialog<FormFieldPickerProps, FormFieldPickerState> {
    static defaultProps: Partial<FormFieldPickerProps> = {};

    constructor(props: FormFieldPickerProps) {
        super(props);
        this.state = {
            IsOpen: true,
            IsBusy: false
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Select a field'
        };
    }

    SubRenderer(): ReactNode {
        return null;
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormFieldPickerProps extends DynamicDialogProps {
    DocumentManager:DocumentManager;
}

interface FormFieldPickerState extends DynamicDialogState {

}




export class FormulaGroup{
    public Label:string;
    public FormulaGroupItems:FormulaGroupItem[];
    public IsOpen:boolean;
    public IsVisible:boolean;

    constructor(label:string) {
        this.FormulaGroupItems=[];
        this.IsOpen=true;
        this.Label=label;
        this.IsVisible=true;


    }

}

export class FormulaGroupItem{
    public Type:string;
    public Value:any;
    public Label:string;
    public IsVisible:boolean;

    public constructor(type:string,label:string,value:any) {
        this.Type=type;
        this.Value=value;
        this.Label=label;
        this.IsVisible=true;
    }

}


//#endregion "My Region"